"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLighterColor = getLighterColor;
exports.getDarkerColor = getDarkerColor;
exports.default = exports.ThemeProvider = exports.SECONDARY = exports.PRIMARY = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _styles = require("@material-ui/core/styles");

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));

var _JssProvider = _interopRequireDefault(require("react-jss/lib/JssProvider"));

var _jss = require("jss");

var _polished = require("polished");

require("typeface-open-sans");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getLighterColor(color) {
  return (0, _polished.mix)(0.25, color, '#FFF');
}

function getDarkerColor(color) {
  return (0, _polished.mix)(0.4, color, '#000');
}

function addLightOrDark(intent, direction, shade, tonalOffset) {
  if (!intent[direction]) {
    if (Object.prototype.hasOwnProperty.call(intent, shade)) {
      intent[direction] = intent[shade]; // eslint-disable-line no-param-reassign
    } else if (direction === 'light') {
      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset); // eslint-disable-line no-param-reassign
    } else if (direction === 'dark') {
      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5); // eslint-disable-line no-param-reassign
    }
  }
}

var PRIMARY = '#00B2CA';
exports.PRIMARY = PRIMARY;
var SECONDARY = '#BFEBF1'; // A theme with custom primary and secondary color.
// It's optional.

exports.SECONDARY = SECONDARY;

var getTheme = function getTheme() {
  var customTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var initialTheme = {
    palette: {
      tonalOffset: 0.3,
      common: {
        black: '#303030'
      },
      primary: {
        main: PRIMARY
      },
      secondary: {
        main: SECONDARY
      },
      error: {
        main: '#ff8468'
      },
      warning: {
        main: '#ffc655'
      },
      success: {
        main: '#66dcaa'
      },
      text: {
        disabled: '#989898',
        dark: '#303030',
        greyBase: '#646464',
        white: '#ffffff'
      },
      contrastThreshold: 2.5,
      getLighterColor: getLighterColor,
      getDarkerColor: getDarkerColor
    },
    typography: {
      useNextVariants: true,
      fontFamily: '"Open Sans", sans-serif',
      fontSize: 14,
      fontWeightRegular: 400,
      fontWeightSemiBold: 600,
      fontWeightBold: 700,
      h1: {
        fontSize: '24px'
      },
      h2: {
        fontSize: '20px'
      },
      h3: {
        fontSize: '18px'
      },
      h5: {
        fontSize: '24px',
        fontWeight: 700,
        margin: '16px 0',
        marginTop: '32px',
        lineHeight: '33px'
      },
      h6: {
        fontSize: '18px',
        fontWeight: 700,
        margin: '16px 0',
        lineHeight: '24px'
      },
      subtitle1: {
        fontSize: '16px'
      },
      body2: {
        fontSize: '14px',
        color: '#303030',
        lineHeight: '21px'
      },
      caption: {
        fontSize: '12px'
      },
      button: {
        fontSize: '14px',
        fontWeight: 600,
        textTransform: 'uppercase'
      }
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 320,
        md: 768,
        lg: 1280
      }
    },
    spacing: {
      unit: 16
    }
  };
  var theme = (0, _styles.createMuiTheme)((0, _deepmerge.default)(initialTheme, customTheme));
  addLightOrDark(theme.palette.warning, 'light', 300, theme.palette.tonalOffset);
  addLightOrDark(theme.palette.warning, 'dark', 700, theme.palette.tonalOffset);
  theme.palette.warning.contrastText = theme.palette.getContrastText(theme.palette.warning.main);
  addLightOrDark(theme.palette.success, 'light', 300, theme.palette.tonalOffset);
  addLightOrDark(theme.palette.success, 'dark', 700, theme.palette.tonalOffset);
  theme.palette.success.contrastText = theme.palette.getContrastText(theme.palette.success.main);
  return theme;
};

var generateClassName = (0, _styles.createGenerateClassName)();
/*
const jss = create(jssPreset());
// We define a custom insertion point that JSS will look for injecting the styles in the DOM.
jss.options.insertionPoint = document.getElementById('jss-insertion-point');
*/

var jss = (0, _jss.create)(_objectSpread({}, (0, _styles.jssPreset)(), {
  // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
  insertionPoint: document.getElementById('jss-insertion-point')
}));

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  var customTheme = getTheme(theme);
  return _react.default.createElement(_JssProvider.default, {
    jss: jss,
    generateClassName: generateClassName
  }, _react.default.createElement(_react.Fragment, null, _react.default.createElement(_CssBaseline.default, null), _react.default.createElement(_styledComponents.ThemeProvider, {
    theme: customTheme
  }, _react.default.createElement(_styles.MuiThemeProvider, {
    theme: customTheme
  }, children))));
};

exports.ThemeProvider = ThemeProvider;
ThemeProvider.defaultProps = {
  theme: {}
};
var _default = ThemeProvider;
exports.default = _default;